<template>
	<div class="business-global-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					<strong>{{
						$t('new_ui.business_global_page_v2.sec_10.title.one')
					}}</strong>
					{{ $t('new_ui.business_global_page_v2.sec_10.title.two') }}
				</h2>
				<p>
					{{ $t('new_ui.business_global_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.business_global_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_global_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.business_global_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img :src="img.imgBusinessGlobalSec10" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-02">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.business_global_page_v2.sec_02.title.one') }}<br />
					{{ $t('new_ui.business_global_page_v2.sec_02.title.two') }}
				</h3>
				<p class="description">
					{{ $t('new_ui.business_global_page_v2.sec_02.desc.one') }}
				</p>

				<div class="step-box">
					<ul>
						<li>
							<img :src="img.imgBusinessGlobalStep01" alt="" />
							<p>
								{{ $t('new_ui.business_global_page_v2.sec_02.step.one.one') }}
								<br />{{
									$t('new_ui.business_global_page_v2.sec_02.step.one.two')
								}}
							</p>
						</li>
						<li v-if="isMobile"><img :src="img.imgDot" alt="" /></li>
						<li>
							<img :src="img.imgBusinessGlobalStep02" alt="" />
							<p>
								{{ $t('new_ui.business_global_page_v2.sec_02.step.two.one') }}
							</p>
						</li>
						<li v-if="isMobile"><img :src="img.imgDot" alt="" /></li>
						<li>
							<img :src="img.imgBusinessGlobalStep03" alt="" />
							<p>
								{{ $t('new_ui.business_global_page_v2.sec_02.step.three.one')
								}}<br />
								{{ $t('new_ui.business_global_page_v2.sec_02.step.three.two') }}
							</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box content-01">
					<h3>
						{{ $t('new_ui.business_global_page_v2.sec_11.one.title.one')
						}}<br />
						{{ $t('new_ui.business_global_page_v2.sec_11.one.title.two') }}
					</h3>
				</div>
				<div class="content-box content-02">
					<h3>
						{{ $t('new_ui.business_global_page_v2.sec_11.two.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.business_global_page_v2.sec_11.two.desc.one') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgBusinessGlobalSec10 from '@/assets/images/v2/img-business-global-sec-10.png';
import imgBusinessGlobalStep01 from '@/assets/images/v2/img-business-global-step-01.png';
import imgBusinessGlobalStep02 from '@/assets/images/v2/img-business-global-step-02.png';
import imgBusinessGlobalStep03 from '@/assets/images/v2/img-business-global-step-03.png';
import imgDot from '@/assets/images/v2/img-dot.png';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgBusinessGlobalSec10,
				imgBusinessGlobalStep01,
				imgBusinessGlobalStep02,
				imgBusinessGlobalStep03,
				imgDot,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
